import * as React from "react";
import { AcceptedInputType, isSelect, Select } from "./Input";
import DoubleClickToActivate from "./DoubleClickToActivate";
import Editable from "./Editable";
import { identity, formatTextArea, createFormatSelect, Formatter } from "./formatters";

interface DoubleClickToEditProps {
  value: any;
  formatter?: Formatter;
  acceptedInput: AcceptedInputType;
  rows?: number;
  onSave: (value: any) => Promise<any>;
  leanRight?: boolean;
  disabled?: boolean;
}

function getFormatter(input: AcceptedInputType): Formatter {
  if (input === "textarea") {
    return formatTextArea;
  }
  if (isSelect(input)) {
    return createFormatSelect((input as Select).options);
  }
  return identity;
}

const DoubleClickToEdit: React.SFC<DoubleClickToEditProps> = (props: DoubleClickToEditProps) => {
  const { disabled, value, acceptedInput, rows, onSave, leanRight } = props;
  const { formatter = getFormatter(acceptedInput) } = props;
  const [active, setActive] = React.useState(false);
  return disabled ? (
    <>{formatter(value)}</>
  ) : (
    <DoubleClickToActivate active={active} setActive={setActive} leanRight={leanRight}>
      {{
        initial: formatter(value),
        activated: (
          <Editable
            value={value}
            acceptedInput={acceptedInput}
            rows={rows}
            onSave={onSave}
            onSuccess={() => {
              setTimeout(() => {
                setActive(false);
              }, 500);
            }}
          />
        ),
      }}
    </DoubleClickToActivate>
  );
};

export default DoubleClickToEdit;
